import { Component, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import { WxrlActionHeader } from '../../services/wxrl-rules.service';

@Component({
  selector: 'afoone-wxrl-rule-actions',
  templateUrl: './wxrl-rule-actions.component.html',
  styleUrls: ['./wxrl-rule-actions.component.css']
})
export class WxrlRuleActionsComponent {
  @Input()
  public actionsFormArray: FormArray;

  @Input()
  public canEdit: boolean = false;

  @Input()
  public actionHeader: WxrlActionHeader | null = null;

  /** Estados de acción { value: Schl, label: Schluessel } para mostrar la etiqueta en la tabla */
  @Input()
  public actionStates: Array<{ value: string; label: string }> = [];

  get actions() {
    return this.actionsFormArray?.controls || [];
  }

  getStateLabel(ruleState: string | undefined): string {
    if (ruleState == null || ruleState === '') return ruleState ?? '';
    const match = this.actionStates?.find((s) => s.value === ruleState);
    return match?.label ?? ruleState;
  }
}
